<template>
  <div class="order-detail"
       v-if="data.orderPersonalData">
    <div class="common-box">
      <div class="order-num c9">
        <div>订单编号：<span class="num-family">{{data.orderNo}}</span></div>
        <div><i class="el-icon-download icon"></i><i class="el-icon-printer icon"></i></div>
      </div>
      <div class="name">{{data.orderPersonalData.name}}的{{data.type}}计划<img src="/img/bg/success-icon.png"
             class="status-icon"></div>
      <div class="c9">公益项目信息化管理系统</div>
    </div>
    <div class="order-info-container">
      <div class="common-box">
        <div class="o-title">基本信息</div>
        <div class=" order-info">
          <img :src="data.orderPersonalData.photoUrl"
               class="photo">
          <div class="info">
            <div class="line"><span class="cae">姓名：</span>{{data.orderPersonalData.name}}</div>
            <div class="line"><span class="cae">性别：</span>{{data.orderPersonalData.gender}}</div>
            <div class="line"><span class="cae">出生年月：</span>{{data.orderPersonalData.birthday}}</div>
            <div class="line"><span class="cae">身份证：</span>
              {{ idCardType ? '******************': data.orderPersonalData.cardNo}}
              <img :src="idCardType ?  imgUrl1: imgUrl2"
                   @click='changeIdcard'
                   class="eye_class"
                   alt="">
            </div>
            <div class="line"><span class="cae">类型：</span>{{data.crimeType}}</div>
            <div class="line"><span class="cae">状态：</span>{{data.status}}</div>
            <div class="order-list-item">
              <!-- <div class="item">
                <div class="pain">0次</div>
                <div class="btn one">综合援助</div>
              </div>
              <div class="item">
                <div class="pain">3次</div>
                <div class="btn two">思政教导</div>
              </div>
              <div class="item">
                <div class="pain">0次</div>
                <div class="btn three">政策救助</div>
              </div> -->
            </div>
          </div>
          <div class="qr-code-container">
            <div class="ewm"
                 id="qrcode"></div>
            <!-- <img src="/img/bg/ewm.jpg" class="ewm"> -->
            <div>档案编号：<span>{{data.caseArchivedNo}}</span></div>
            <div class="mb10">扫码可以预览案情</div>
            <el-button type="primary"
                       plain
                       @click="getCaseArchivedDetail">档案详情</el-button>
          </div>
        </div>
      </div>
      <div class="common-box">
        <div class="o-title">当前订单参与具体计划帮扶机构</div>
        <div class="radder-chart" v-if="radderShow">
          <!-- <radder></radder> -->
          <radderChart ref="radderChart"></radderChart>
        </div>
        <div style="height: 200px;display: flex;justify-content: center;align-items: center;" v-else>
          <div class="avue-empty">
            <div class="avue-empty__image" style="height: 50px;"><img
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
                alt=""></div>
            <p class="avue-empty__desc">暂无数据</p>
          </div>
        </div>
        <!-- <div class="radder-info">
          <div class="item">
            <div>具体计划数</div>
            <div class="mt10 c6">14</div>
          </div>
          <div class="item">
            <div>完成情况</div>
            <div class="mt10 c6">14</div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="common-box mt15">
      <div class="o-title">流程进度</div>
      <el-steps size="mini"
                :active="data.starOrderStatusList.length-1"
                align-center
                class="order-steps">
        <el-step v-for="(item,index) in starOrderStatusList"
                 :title="item.dictValue"
                 :key="index">
          <template slot="icon"
                    v-if="data.starOrderStatusList[index]">
            <el-popover placement="top-start"
                        width="200"
                        trigger="hover">
              <div v-if="item.dictKey*1 == 55">
                <div class="flex"
                     v-for="(plan,n) in data.orderInitialPlanList"
                     :key="n">
                  <div>{{plan.initPlanCreateDeptName}}</div>
                  <div>{{plan.confirmedTime}}</div>
                </div>
              </div>
              <div v-if="item.dictKey*1 == 60">
                <div v-for="(plan,n) in data.orderInitialPlanList"
                     :key="n">
                  <div class="flex">
                    <div>创建人：{{data.starOrderStatusList[index].createUserName}}</div>
                    <el-button type="text"
                               @click="openJtjhHandle(plan)"
                               v-if="item.dictKey*1 == 60">具体计划单</el-button>
                  </div>
                  <div>机构：{{data.starOrderStatusList[index].createDeptName}}</div>
                  <div>时间：{{data.starOrderStatusList[index]?getDateFormate(data.starOrderStatusList[index].createTime):''}}</div>
                </div>
              </div>
              <div v-else>
                <div class="flex">
                  <div>创建人：{{data.starOrderStatusList[index].createUserName}}</div>
                  <el-button type="text"
                             @click="orderDetailVisible=true"
                             v-if="item.dictKey*1 == 20 || item.dictKey*1 == 30 || item.dictKey*1 == 70||item.dictKey*1==80||item.dictKey*1==90">详情</el-button>
                  <el-button type="text"
                             @click="pdflVisible=true"
                             v-if="item.dictKey*1 == 40||item.dictKey*1 == 50">计划单</el-button>
                  <el-button type="text"
                             @click="pdflVisible1=true"
                             v-if="item.dictKey*1 == 40">社会调查</el-button>
                  <!-- <el-button type="text" @click="pdfljtVisible=true" v-if="item.dictKey*1 == 60">具体计划单</el-button> -->
                  <el-button type="text"
                             @click="pdfOnlinelVisible=true"
                             v-if="item.dictKey*1 == 100">查看</el-button>
                </div>
                <div>机构：{{data.starOrderStatusList[index].createDeptName}}</div>
                <div>时间：{{data.starOrderStatusList[index]?getDateFormate(data.starOrderStatusList[index].createTime):''}}</div>
              </div>
              <div slot="reference"
                   @click="openDetailDialog(data.starOrderStatusList[index])"><b>{{index+1}}</b></div>
            </el-popover>
          </template>
          <template slot="description">
            <div class="c9">{{data.starOrderStatusList[index]?data.starOrderStatusList[index].createUserName:''}}</div>
            <div class="c9">{{data.starOrderStatusList[index]?getDateFormate(data.starOrderStatusList[index].createTime):''}}</div>
          </template>
        </el-step>
      </el-steps>
    </div>
    <el-dialog title="具体计划单"
               append-to-body
               width="80%"
               :visible.sync="pdfljtVisible"
               custom-class="common-dialog"
               class="avue-dialog">
      <jtPdf :info="jtjhDetail"
             @close="pdfljtVisible = false"></jtPdf>
    </el-dialog>
    <el-dialog title="订单详情"
               fullscreen
               append-to-body
               width="80%"
               :visible.sync="orderDetailVisible">
      <pdf :info="data"
           :type="1"
           @close="orderDetailVisible = false"></pdf>
    </el-dialog>
    <el-dialog title="初始计划单"
               append-to-body
               width="80%"
               :visible.sync="pdflVisible"
               custom-class="common-dialog"
               class="avue-dialog">
      <csPdf :info="data"
             @close="pdflVisible = false"></csPdf>
    </el-dialog>
    <el-dialog title="社会调查报告"
               append-to-body
               width="100%"
               :visible.sync="pdflVisible1"
               custom-class="common-dialog"
               class="avue-dialog">
      <investpdf :info="data"
                 @close="pdflVisible1 = false"></investpdf>
    </el-dialog>
    <el-dialog title="查看报告"
               append-to-body
               width="80%"
               :visible.sync="pdfOnlinelVisible"
               custom-class="common-dialog"
               class="avue-dialog">
      <reportpdf :info="data"
                 @close="pdfOnlinelVisible = false"></reportpdf>
    </el-dialog>
    <el-dialog title="档案详情"
               fullscreen
               append-to-body
               width="80%"
               :visible.sync="orderDetailVisible1">
      <pdf :info="caseDetail"
           :dosserId="dosserId"
           :type="2"
           @close="orderDetailVisible1 = false"></pdf>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'peachill-qrcode';
import { getOrderInfo,specificPlanOfOrderData} from "@/api/order/index";
import { getDictionary } from '@/api/system/dictbiz'
import radder from '@/components/chart/radder.vue'
import { dateFormat } from '@/util/date'
import { deepClone } from '@/util/util'
import jtPdf from '@/views/archives/components/jtjh-pdf.vue'
import radderChart from "@/components/chart/radderChart.vue";
import investpdf from '@/views/archives/components/investigation-pdf.vue'
import pdf from '@/views/archives/components/order-detail-pdf.vue'
import csPdf from '@/views/archives/components/lzjh-pdf.vue'
import reportpdf from '@/views/archives/components/report-pdf.vue'
import { getArchivesDetailByOrderId } from '@/api/archives/index'
export default {
  name: 'order-detail',
  components: {
    radder,
    pdf,
    csPdf,
    investpdf,
    jtPdf,
    radderChart,
    reportpdf
  },
  data () {
    return {
      dosserId: "",
      caseDetail: {},
      orderDetailVisible1: false,
      data: {},
      starOrderStatusList: [],
      timer: null,
      qrcode: null,
      text: "",
      jtjhDetail: {},
      pdfljtVisible: false,
      orderDetailVisible: false,
      pdflVisible: false,
      pdflVisible1: false,
      pdfOnlinelVisible: false,
      idCardType: true,
      radderShow: true,
      imgUrl1: require('../../static/images/common/show.png'),
      imgUrl2: require('../../static/images/common/hide.png'),
    }
  },
  created () {
    if (this.$route.query.id) {
      this.getDetail()
    }
  },
  computed: {
    getDateFormate () {
      return function (date) {
        return dateFormat(new Date(date), "yyyy-MM-dd")
      }
    }
  },
  methods: {
    // 查询某个订单对应人员的具体计划的参与机构统计数据
    loadSpecificPlanOfOrderDataWay(id){
      specificPlanOfOrderData({
        orderId:id
      }).then(res => {
        // this.personalWorkTypeData = res.data.data;
        if (res.data.data == "") {
          this.radderShow = false;
          return;
        }
        this.radderShow = true;
        let returnData = {
          xAxisData: [],
          seriesData: []
        }
        for (var key in res.data.data) {
          returnData.xAxisData.push(res.data.data[key].deptName);
          returnData.seriesData.push(res.data.data[key].cnt);
        }
        this.$refs.radderChart.setOptions(returnData);
        console.log("查询某个订单对应人员的具体计划的参与机构统计数据",res.data.data);
      })
    },
    changeIdcard () {
      this.idCardType = !this.idCardType
    },
    openJtjhHandle (plan) {
      this.jtjhDetail = deepClone(this.data)
      this.jtjhDetail.orderInitialPlanList = this.jtjhDetail.orderInitialPlanList.filter(v => v.id == plan.id)
      this.pdfljtVisible = true
    },
    async getDictByValue (key, value, code, type) {
      let res = await getDictionary({ code: code })
      let obj = res.data.data.find(v => v.dictKey == value)
      if (!obj) return
      if (type == 1) {
        this.$set(this.data, key, obj.dictValue)
      } else {
        this.$set(this.data.orderPersonalData, key, obj.dictValue)
      }

    },
    getDetail () {
      getOrderInfo(this.$route.query.id).then(res => {
        this.data = res.data.data
        this.jtjhDetail = this.data
        this.loadSpecificPlanOfOrderDataWay(this.$route.query.id);
        console.log("当前data",this.data);
        this.getDictByValue('type', this.data.type, 'work_type', 1)
        this.getDictByValue('status', this.data.status, 'order_status', 1)

        this.getDictByValue('gender', this.data.orderPersonalData.gender, 'sex', 2)
        this.getDictByValue('crimeType', this.data.crimeType, 'crime_types', 1)
        getDictionary({ code: 'order_status' }).then(res => {
          this.starOrderStatusList = res.data.data
        })
        setTimeout(() => {
          this.init()
        }, 200)

      })
    },
    init () {

      this.text = `https://` + window.location.host + `/mobile/#/home?id=${this.data.id}&n=${Math.floor(Math.random() * 10 + 1)}` || '没有这个订单'

      // this.text = `https://www.hjbjx.cn/mobile/#/home?id=${this.data.id}&n=${Math.floor(Math.random() * 10 + 1)}` || '没有这个订单'

      this.qrcode = new QRCode("#qrcode", {
        text: this.text,
        linearGradient: true,
        linearGradientDirection: 'to bottom right',
        linearGradientFrom: '#E2AE28',
        linearGradientTo: '#40948A',
        linearGradientMiddle: '#E3821B',
        linearGradientMiddle2: '#6EB691'
      });
      this.timer = setInterval(() => {
        this.refreshQrcodeHandle()
      }, 60000);
    },
    refreshQrcodeHandle () {

      this.text = `https://` + window.location.host + `/mobile/#/home?id=${this.data.id}&n=${Math.floor(Math.random() * 10 + 1)}` || '没有这个订单'

      // this.text = `https://www.hjbjx.cn/mobile/#/home?id=${this.data.id}&n=${Math.floor(Math.random() * 10 + 1)}` || '没有这个订单'

      this.qrcode.makeCode(this.text)
    },
    getCaseArchivedDetail () {
      getArchivesDetailByOrderId(this.data.id).then(res => {
        this.caseDetail = res.data.data.starOrder
        this.dosserId = res.data.data.id
        this.orderDetailVisible1 = true
      })
    }
  },
  beforeUnmount () {
    clearInterval(this.timer);
    this.timer = null
  }
}

</script>
<style lang="scss" scoped="scoped">
@import "@/styles/moudles/order.scss";
</style>
<style lang="scss">
.order-detail canvas {
  width: 100% !important;
  height: 100% !important;
}

.order-list-item {
  display: flex;
  margin-top: 20px;

  .item {
    flex: 1;
    text-align: center;

    .pain {
      width: 70px;
      line-height: 30px;
      border: 1px solid #eaeaea;
      margin: 0 auto 10px;
    }

    .btn {
      width: 90px;
      line-height: 30px;
      background: #00cd66;
      color: #fff;
      margin: 0 auto;

      &.two {
        background: #0733ff;
      }

      &.three {
        background: #e37b17;
      }
    }
  }
}
</style>
